/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Sales_Return_Fee_HintInputs */

const vi_sales_return_fee_hint = /** @type {(inputs: Sales_Return_Fee_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phần tiền khách đã trả mà bên bán giữ lại, không hoàn (vd khách đổi ý, hàng đã bóc). Tối đa ${i?.max}. Để trống nếu không thu phí.`)
};

/**

* @param {Sales_Return_Fee_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_fee_hint = /** @type {((inputs: Sales_Return_Fee_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Fee_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_fee_hint(inputs)
});